<template>
  <div>
    <my-work-table :data="data" :loading="loading" @getData="getData"></my-work-table>
  </div>
</template>

<script>
import myWorkTable from './myWorkTable'
export default {
  props: [
    'data',
    'loading'
  ],
  data () {
    return {
      btnLoadinng: false
    }
  },
  methods: {
    getData () {
      this.$emit('getData')
    }
  },
  components: {
    myWorkTable
  }
}
</script>

<style lang="scss" scoped>
</style>
